import React from "react";
import ErrorBoundary from "lib/ErrorBoundary";
import { NotFound } from "pages/login/NotFound";
import { LoadingSpinner } from "lib/Spinner";
import { NotAvailable } from "lib/SimpleTable";
import { useFetchLandingPage } from "./useFetchLandingPage";
import {
  PocHtmlContent,
  PromotedPublications,
  LandingPublications,
  PocHashtagPublications,
  LandingPageAdverts,
} from "./parts/LandingPageParts";
import "./brochure.css";

export function LandingPage({ match }) {
  const [pageData, isLoading, error] = useFetchLandingPage(match.params.topic);

  if (isLoading) return <LoadingSpinner />;
  if (error) return <NotAvailable />;
  if (!pageData) return <NotFound />;
  if (
    pageData.redirect_link !== undefined &&
    pageData.redirect_link !== "" &&
    window.location.href !== pageData.redirect_link
  ) {
    window.location.href = pageData.redirect_link;
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <></>;
  }
  return <LandingPageView {...pageData} contentPath="1" />;
}

function LandingPageView({
  html_content,
  reportFilter,
  featuredReportFilter,
  hashtags,
  html_file,
  advert_ids,
  template_style,
  title,
}) {
  return (
    <ErrorBoundary>
      <section className="position-relative px-2">
        <div dangerouslySetInnerHTML={{ __html: html_content }} className={`landing-page ${template_style}`} />
        {html_file && <PocHtmlContent filename={html_file} />}
        {advert_ids && <LandingPageAdverts advertIds={advert_ids} />}
        {featuredReportFilter && <PromotedPublications filter={featuredReportFilter} />}
        {reportFilter && <LandingPublications filter={reportFilter} title={title} />}
        {hashtags && <PocHashtagPublications hashtags={hashtags} />}
      </section>
    </ErrorBoundary>
  );
}
